/* eslint-disable indent */
/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import { isEmpty, groupBy } from 'lodash';
import campaignService from '@/services/toolbox/campaign-service';
import {
	getDefaultControls,
	getBrandBuilderEditorIntialState,
} from './brand-builder-editor-initial-state';
import { CAMPAIGN_ID, AUDIENCE_ID } from '@/constants/brand-builder';

const state = getBrandBuilderEditorIntialState();

const mutations = {
	SET_BRANDBUILDER_STATE(state, payload) {
		/* NOTE: Use the Object.assign syntax here. Otherwise the state change detection
		  doesn't register until AFTER the CampaignEditorWorkspace.vue mounts */
		Object.assign(state, payload);
	},
	RESET_BRANDBUILDER_STATE() {
		const initialState = getBrandBuilderEditorIntialState();
		Object.assign(state, initialState);
	},
	SET_PRICING_SUBHEADING(state, payload) {
		/* Used by Pricing Flyer to add a placeholder address to subheader */
		state.selectedControls.controls[0].items[1].value = payload;
		state.controlValues.titleText = payload;
	},
	SET_DEFAULT_ITEMS(state) {
		state.controlValues['headerText'] = 'This is the Header';
		state.controlValues['titleText'] = 'This is the Title';
		state.controlValues['bodyText'] = 'This is the body';
		state.controlValues['endingTagLineText'] = 'This is the endling line';
		state.controlValues['Primary'] = '#fff';
		state.controlValues['Secondary'] = '#fff';
	},
	SET_CAMPAIGN_LOADING_STATUS(state, payload) {
		state.campaignLoading = payload;
	},
	SET_CAMPAIGN_ID(state, payload) {
		state.campaignId = payload;
	},
	UPDATE_ITEMS(state, payload) {
		state.campaignItems = payload.items;
		state.campaignId = payload.campaignId;
	},
	UPDATE_VARIATIONS(state, payload) {
		state.campaignItems = payload;
	},
	UPDATE_DISCLAIMERS(state, payload) {
		// eslint-disable-next-line func-names, prefer-arrow-callback
		state.campaignDisclaimers = [...payload].map(function (e) {
			return e.content;
		});
	},
	SET_COLOR_INDEX(state, payload) {
		state.selectedColorIndex = payload;
	},
	SET_DESIGN_INDEX(state, payload) {
		state.selectedDesignIndex = payload;
	},
	SELECT_IMAGE(state, payload) {
		if (payload) {
			state.selectedImage = payload;
			// eslint-disable-next-line dot-notation
			state.controlValues['Image'] = payload.uri.replace(
				/https:\/\/res\.cloudinary\.com\/uwm\/image\/upload\//gim,
				'',
			);
		} else {
			state.selectedImage = null;
		}
	},
	CLEAR_SELECTED_CONTROLS(state) {
		state.selectedControls = null;
	},
	SELECT_DESIGN(state, payload) {
		// TODO: once there are more than one pricing designs the itemtype !== 6 condition needs to be removed
		// if (typeof payload !== 'undefined' && payload.item.itemType.itemTypeId !== 6) {
		if (typeof payload !== 'undefined') {
			state.selectedDesign = payload;
			state.selectedItem = payload.item;
			state.selectedTemplate = payload.template;
			// if we don't have selected controls set to controls of first variation on the item
			if (isEmpty(state.selectedControls)) {
				// eslint-disable-next-line prefer-destructuring
				state.selectedControls = payload.item.variations[0];
			}
		}
	},

	/* Sets the selected media type and marks an item as selected on the mediaTypeArray */
	SELECT_MEDIA_TYPE(state, payload) {
		const updatedMediaTypeArray = state.mediaTypeArray.map((item) => {
			const newItem = item;
			if (newItem === payload) {
				newItem.selected = true;
			} else {
				newItem.selected = false;
			}
			return newItem;
		});
		state.mediaTypeArray = updatedMediaTypeArray;
		state.selectedMediaType = payload.index;
	},

	SELECT_AUDIENCE_TYPE(state, payload) {
		const updatedAudienceTypeArray = state.audienceTypeArray.map((item) => {
			const newItem = item;
			if (newItem === payload) {
				newItem.selected = true;
			} else {
				newItem.selected = false;
			}
			return newItem;
		});
		state.audienceTypeArray = updatedAudienceTypeArray;
		state.selectedAudienceType = payload.index;
		state.selectedCopyVariationIndex = 0;

		state.filteredItems = state.campaignItems.filter(
			(x) =>
				x.itemType.itemTypeId === state.selectedMediaType &&
				x.audiences
					.map((y) => y.audienceId)
					.indexOf(state.selectedAudienceType) >= 0,
		);
	},
	SELECT_SOCIAL_TYPE(state, payload) {
		const updatedSocialArray = state.socialArray.map((item) => {
			const newItem = item;

			if (newItem === payload) {
				newItem.selected = true;
			}

			return newItem;
		});
		state.socialArray = updatedSocialArray;
	},
	SELECT_FLYER_CONTENT(state, payload) {
		const updatedSelectFlyerArray = state.selectFlyer[0].fakeDataArray.map(
			(item) => {
				const newItem = item;
				if (newItem === payload) {
					newItem.selected = true;
				} else {
					newItem.selected = false;
				}
				return newItem;
			},
		);
		state.selectFlyer[0].fakeDataArray = updatedSelectFlyerArray;
		this.$ga.event({
			eventCategory: 'brand builder editor',
			eventAction: `${payload} flyer selected`,
			eventLabel: 'in flyer selector',
		});
	},
	SELECT_COPY_VARIATION(state, payload) {
		state.selectedTextVariationIndex = payload;
	},
	SET_CAMPAIGN_ITEMS_MEDIAS_LOADING(state, payload) {
		state.variationMediasLoading = payload;
		state.campaignItemMediasLoading = payload;
	},
	SET_CAMPAIGN_ITEMS_MEDIAS(state, payload) {
		state.mediasByVariantId = payload;
	},
	SET_MEDIAS_BY_CAMPAIGN_ITEM_ID(state, payload) {
		state.mediasByCampaignItemId = payload;
	},
	UPDATE_CONTROL_VALUE(state, payload) {
		const updatedCopy = payload.value;
		state.controlValues[payload.fieldName] = updatedCopy;
	},
	SET_MANUAL_EMAIL_DATA(state, payload) {
		state.manualEmailData = payload;
	},
	COMPLETE_VIDEO(state, payload) {
		state.completeVideo = payload;
	},
	RESET_DEFAULT_SELECTIONS(state, { clearMediaType }) {
		if (clearMediaType !== false) {
			state.selectedMediaType = null;
			state.mediaTypeArray = state.mediaTypeArray.map((e) => ({
				...e,
				selected: false,
			}));
			// Clears email/contact data that was set when sending an alert via client connect (LightiningOutInternal component)
			state.manualEmailData = null;
			state.mediasByVariantId = null;
		}
		state.campaignLoading = null;
		state.variationMediasLoading = null;
		state.campaignItemMediasLoading = null;
		state.showLoader = false;
		state.selectedAudienceType = null;
		state.selectedColorIndex = null;
		state.selectedDesignIndex = null;
		state.selectedImageIndex = null;
		state.selectedTextVariationIndex = null;
		state.completeVideo = null;
		state.selectedControls = null;
		state.filteredItems = [];
		state.selectedDesign = null;
		state.selectedItem = null;
		state.selectedTemplate = null;
		state.selectedFlyer = null;
		state.audienceTypeArray = state.audienceTypeArray.map((e) => ({
			...e,
			selected: false,
		}));
		state.socialArray = state.socialArray.map((e) => ({
			...e,
			selected: false,
		}));
		state.selectedVideo = 0;
		state.routeAllowed = {
			design: false,
			additional: false,
		};
	},
	TOGGLE_LOADER(state, payload) {
		if (typeof payload !== 'undefined') {
			state.showLoader = payload;
		} else {
			state.showLoader = !state.showLoader;
		}
	},
	TOGGLE_SM_PREVIEW(state, payload) {
		if (payload === 'on') {
			state.smHideControls = true;
		} else if (payload === 'off') {
			state.smHideControls = false;
		} else {
			state.smHideControls = !state.smHideControls;
		}
	},
	SET_PREV_BBROUTE(state, payload) {
		state.prevBBRoute = payload;
	},
	SET_ROUTE_ALLOWED(state, payload) {
		if (payload.route === 'all') {
			// Don't allow any of the routes
			Object.entries(state.routeAllowed).forEach(([key]) => {
				state.routeAllowed[key] = payload.activated;
			});
		} else {
			state.routeAllowed[payload.route] = payload.activated;
		}
	},
	UPDATE_SELECTED_CONTROL(state, payload) {
		// eslint-disable-next-line object-curly-newline
		const { fieldName, updatedText, value } = payload;
		const htmlContent = value;
		const updatedValue = fieldName === 'bodyText' ? htmlContent : updatedText;
		state.selectedItem.variations[
			state.selectedTextVariationIndex
		].controls[0].items.find((obj) => obj.clientId === fieldName).value =
			updatedValue;
	},
	SET_CLIENT_CONNECT_ALERT_EMAIL_DETAILS(state, payload) {
		state.clientConnectAlertEmail.alertId = payload.alertId;
		state.clientConnectAlertEmail.borrowerFirstName = payload.borrowerFirstName;
		state.clientConnectAlertEmail.borrowerLastName = payload.borrowerLastName;
		state.clientConnectAlertEmail.email = payload.email;
		state.clientConnectAlertEmail.leadId = payload.leadId;
		state.clientConnectAlertEmail.alertType = payload.alertType;
	},

	SET_EMAIL_SUBJECT_LINE(state, subjectLine) {
		state.subjectLine = subjectLine;
	},

	SET_DEFAULT_EMAIL_SUBJECT_LINE(state, subjectLine) {
		state.defaultSubjectLine = subjectLine;
	},
	SET_VIDEO_IS_VERTICAL(state, data) {
		state.videoIsVertical = data;
	},
};

const actions = {
	updatePricingSubheading(context, data) {
		context.commit('SET_PRICING_SUBHEADING', data);
	},
	completeVideoAction(context, videoId) {
		context.commit('COMPLETE_VIDEO', videoId);
	},
	async loadCampaign({ commit, dispatch }, campaignId) {
		commit('SET_CAMPAIGN_LOADING_STATUS', true);
		commit('SET_CAMPAIGN_ID', campaignId);
		const campaignIdCurrentlyLoading = state.campaignId;
		try {
			const campaign = await campaignService.getCampaign(campaignId);

			if (campaignIdCurrentlyLoading === state.campaignId) {
				if (campaignId === CAMPAIGN_ID.PRICING_SCENARIO_FLYER) {
					// Pricing Flyer doesn't have controls in its variation so add them
					campaign.data.items[0].variations[0].controls = getDefaultControls();
				}
				commit('UPDATE_ITEMS', {
					items: campaign.data.items,
					campaignId,
				});

				commit('SET_DEFAULT_EMAIL_SUBJECT_LINE', campaign.data.subject);
				const campaignItemsIds = state.campaignItems.map(
					(item) => item.campaignItemId,
				);

				dispatch('loadCampaignItemMedias', campaignItemsIds);

				commit('SET_EMAIL_SUBJECT_LINE', campaign.data.subject);

				if (campaignId === CAMPAIGN_ID.PRICING_SCENARIO_FLYER) {
					/* For pricing flyer automatically make initial selections */
					dispatch('initialCampaignSelections');
				}
				commit('SET_CAMPAIGN_LOADING_STATUS', false);
				let { disclaimers } = campaign.data;
				if (
					campaignId === CAMPAIGN_ID.FHA ||
					campaignId === CAMPAIGN_ID.THREE_PERCENT_DOWN
				) {
					/* For FHA and 3% Down remove their default disclaimer and then get
					a "trigger" version for $200,000, which will be the default  */
					disclaimers = [...disclaimers].filter(
						(e) =>
							e.campaignDisclaimerId !== 11 && e.campaignDisclaimerId !== 20,
					);
					const disclaimerResponse =
						await campaignService.getCampaignDisclaimer(
							parseInt(campaignId, 10),
							200000.0,
						);
					commit('UPDATE_DISCLAIMERS', [
						{ content: disclaimerResponse.disclaimer },
					]);
				} else {
					commit('UPDATE_DISCLAIMERS', disclaimers);
				}
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error('Unable to load campaign.', err);
			commit('SET_CAMPAIGN_LOADING_STATUS', false);
		}
	},
	async loadCampaignItemMedias({ commit, dispatch }, campaignItemsIds) {
		commit('SET_CAMPAIGN_ITEMS_MEDIAS_LOADING', true);
		const campaignIdCurrentlyLoading = state.campaignId;
		try {
			const mediasResponse = await campaignService.getMediasForCampaignItems(
				campaignItemsIds,
			);
			if (campaignIdCurrentlyLoading === state.campaignId) {
				if (mediasResponse.data.length > 0) {
					//  group data by variationId for easier access later (normalization)
					const mediasByVariationId = groupBy(
						mediasResponse.data,
						'variationId',
					);
					const mediasByCampaignItemId = groupBy(
						mediasResponse.data,
						'campaignItemId',
					);
					commit('SET_MEDIAS_BY_CAMPAIGN_ITEM_ID', mediasByCampaignItemId);
					commit('SET_CAMPAIGN_ITEMS_MEDIAS', mediasByVariationId);
					dispatch('selectImageByIndex', 0);
				} else {
					commit('SET_CAMPAIGN_ITEMS_MEDIAS', null);
				}
				commit('SET_CAMPAIGN_ITEMS_MEDIAS_LOADING', false);
			}
		} catch (err) {
			// eslint-disable-next-line no-console
			console.error('Unable to load variation medias. ', err);
			commit('SET_CAMPAIGN_ITEMS_MEDIAS_LOADING', false);
		}
	},
	setColorIndex(context, colorIndex) {
		context.commit('SET_COLOR_INDEX', colorIndex);
	},
	setDesignIndex(context, designIndex) {
		context.commit('SET_DESIGN_INDEX', designIndex);
	},
	updateDisclaimers(context, disclaimers) {
		context.commit('UPDATE_DISCLAIMERS', disclaimers);
	},
	selectImageByIndex({ commit, state }, index) {
		const selectedVariationId = state.selectedDesign.item
			? state.selectedDesign.item.variations[state.selectedTextVariationIndex]
					.variationId
			: null;
		const mediaItem = selectedVariationId
			? state.mediasByVariantId[selectedVariationId][index]
			: null;
		commit('SELECT_IMAGE', mediaItem);
	},
	selectImage(context, mediaItem) {
		context.commit('SELECT_IMAGE', mediaItem);
	},
	selectDesign(context, imageId) {
		context.commit('SELECT_DESIGN', imageId);
	},
	selectColors(context, color) {
		// TODO: Refactor, Unused action?
		// Loop over the Colors to insert them into the controls object
		// eslint-disable-next-line no-plusplus
		for (let i = 0; i < color.colors.length; i++) {
			context.commit('UPDATE_CONTROL_VALUE', {
				control: { clientId: color.colors[i].colorType },
				value: color.colors[i].hexCode,
			});
		}
	},
	selectSocialType(context, socialType) {
		context.commit('SELECT_SOCIAL_TYPE', socialType);
	},
	setDefaultItems(context, defaultIdTEMPSOMETHING) {
		context.commit('SET_DEFAULT_ITEMS', defaultIdTEMPSOMETHING);
	},
	selectFlyerContent(context, selectFlyer) {
		context.commit('SELECT_FLYER_CONTENT', selectFlyer);
	},
	selectAudienceType(context, audienceType) {
		context.commit('SELECT_AUDIENCE_TYPE', audienceType);
	},
	selectMediaType(context, mediaType) {
		context.commit('SELECT_MEDIA_TYPE', mediaType);
	},
	selectCopyVariation({ commit, dispatch }, event) {
		commit('SELECT_COPY_VARIATION', parseInt(event.target.value, 10));
		/* If selected copy (or text) variation changes then selectedImage changes
            because images (medias) are tied to the different variations */
		dispatch('selectImageByIndex', 0);
	},
	updateControlValue(context, data) {
		if (
			['titleText', 'headerText', 'bodyText'].includes(data.fieldName) &&
			state.manualEmailData
		) {
			data.value = data.value.replace(
				/\[Borrowername\]\s?/g,
				state.manualEmailData.FirstName,
			);
			// eslint-disable-next-line prefer-template
			data.value = data.value.replace(
				/\[%XX\]\s?/g,
				`${state.manualEmailData.CurrentLTV}%`,
			);
		}
		context.commit('UPDATE_CONTROL_VALUE', data);
	},
	setManualEmailData(context, data) {
		context.commit('SET_MANUAL_EMAIL_DATA', data);
	},
	resetBrandBuilderState(context) {
		context.commit('RESET_BRANDBUILDER_STATE');
	},
	resetDefaultSelections(context, data) {
		context.commit('RESET_DEFAULT_SELECTIONS', data);
	},
	toggleLoader(context, data) {
		context.commit('TOGGLE_LOADER', data);
	},
	toggleSmPreview(context, data) {
		context.commit('TOGGLE_SM_PREVIEW', data);
	},
	setPrevBBRoute(context, data) {
		context.commit('SET_PREV_BBROUTE', data);
	},
	setRouteAllowed(context, data) {
		context.commit('SET_ROUTE_ALLOWED', data);
	},
	updateSelectedControlValue(context, data) {
		// eslint-disable-next-line object-curly-newline
		const { updatedText, fieldName, index, value } = data;

		context.commit('UPDATE_SELECTED_CONTROL', {
			updatedText,
			fieldName,
			index,
			value,
		});
	},
	initialCampaignSelections({ commit, dispatch }) {
		/* initialCampaignSelections is called to set the initial (or default)
		selections after the user selects a media and audience type */

		/* This automatically selects the Audience Type for Pricing Flyer
		because the user doesn't manually select one. */
		if (state.selectedAudienceType === AUDIENCE_ID.BORROWER) {
			commit('SELECT_AUDIENCE_TYPE', state.audienceTypeArray[0]);
		}
		commit('SET_DESIGN_INDEX', 0);
		commit('CLEAR_SELECTED_CONTROLS');
		const initialSelectedDesign = {
			item: state.filteredItems[0],
			template: state.filteredItems[0].templates[0],
		};
		commit('SELECT_DESIGN', initialSelectedDesign);
		// Load variations for other campaigns
		commit('SELECT_COPY_VARIATION', 0);
		const campaignItemsIds = state.campaignItems.map(
			(item) => item.campaignItemId,
		);
		if (state.mediasByVariantId === null || state.mediasByCampaignItemId) {
			dispatch('loadCampaignItemMedias', campaignItemsIds);
		} else {
			dispatch('selectImageByIndex', 0);
		}
		/* Default color index (ie palette) is 3 because 1 and 2
		are user and company palettes which aren't selected by default.
		3 is the first campaign palette. */
		commit('SET_COLOR_INDEX', 3);
	},
	setClientConnectAlertEmailDetails({ commit }, payload) {
		commit('SET_CLIENT_CONNECT_ALERT_EMAIL_DETAILS', payload);
	},
	setEmailSubjectLine({ commit }, payload) {
		commit('SET_EMAIL_SUBJECT_LINE', payload);
	},
	setVideoIsVertical({ commit }, data) {
		commit('SET_VIDEO_IS_VERTICAL', data);
	},
};

const getters = {
	selectedVariationMedias(state) {
		const selectedVariationId =
			state.selectedItem.variations[state.selectedTextVariationIndex]
				.variationId;
		return state.mediasByVariantId[selectedVariationId];
	},
	/* For videos there can only be one selected design for a particular audience.
	Each design only has one variation. That variation may have several media items (or videos).
	The selectedDesignIndex determines which of these items is selected. */
	selectedVideo(state) {
		// eslint-disable-next-line prefer-destructuring
		const campaignItemId = state.selectedDesign.item.campaignItemId;
		return state.mediasByCampaignItemId
			? state.mediasByCampaignItemId[campaignItemId][state.selectedDesignIndex]
			: null;
	},
	selectedDesignFirstVariation(state) {
		if (state.mediasByVariantId) {
			const { variationId } = state.selectedDesign.item.variations[0];
			return state.mediasByVariantId[variationId];
		}
		return null;
	},
	selectedDesignCampaignItem(state) {
		if (state.mediasByCampaignItemId) {
			const campaignItemId =
				state.selectedDesign && state.selectedDesign.item.campaignItemId;
			return state.mediasByCampaignItemId[campaignItemId];
		}
		return null;
	},
	/*
		partnerPointsProfile returns an object with properties used for LoPP
		@return object: userId from user-profile, campaignId & selectedMediaType from brand builder
	 */
	partnerPointsProfile(state) {
		// eslint-disable-next-line arrow-body-style
		return () => {
			return {
				campaignType:
					state.filteredItems && state.filteredItems.length > 0
						? state.filteredItems[0].campaignId
						: state.campaignItems[0].campaignId,
				mediaType: state.selectedMediaType,
			};
		};
	},
};

export default {
	state,
	actions,
	mutations,
	getters,
};
